[
    [1,1,"Common Diagnosis",0,0],
    [2,2,"Normal heart",1,0],
    [3,2,"Echogenic foci",1,0],
    [4,2,"Normal conduction",1,0],
    [5,2,"Difficulty - partial exam",1,0],
    [6,2,"Decreased cardiac function",1,0],
    [7,2,"Cardiomegaly",1,0],
    [8,2,"Volume overload",1,0],
    [9,2,"Retrograde ductal flow",1,0],
    [10,2,"DA patency for observation",1,0],
    [11,2,"Persistent Left SVC draining to dilated coronary sinus",1,0],
    [12,2,"Premature closure of foramen ovale",1,0],
    [13,2,"Premature restriction of foramen ovale",1,0],
    [14,2,"Septum primum aneurysm",1,0],
    [15,2,"VSD",1,0],
    [16,2,"Inlet VSD",1,0],
    [17,2,"Muscular VSD ",1,0],
    [18,2,"Perimembranous VSD ",1,0],
    [19,2,"Ascending aorta dilation",1,0],
    [20,2,"Maternal anti Ro / La antibodies",1,0],
    [21,2,"Fetal arterial duct narrowing/ closure",1,0],
    [22,2,"Ductus arteriosus torteous",1,0],
    [23,2,"Aortic arch for observation",1,0],
    [24,2,"Premature atrial complexes",1,0],
    [25,2,"Abnormal isthmic flow",1,0],
    [26,2,"Fetal bradycardia",1,0],
    [27,1,"Atrial abnormality",0,0],
    [28,2,"Coronary sinus dilatation",27,0],
    [29,2,"Giant RA",27,0],
    [30,2,"LA dilation",27,0],
    [31,2,"LA hypoplasia",27,0],
    [32,2,"Cor triatriatum (divided left atrium)",27,0],
    [33,2,"Common atrium (virtual absence of atrial septum)",27,0],
    [34,2,"Pulmonary veins anomaly",27,0],
    [35,2,"Anomalous pulmonary venous connection",27,0],
    [36,2,"Totally anomalous pulmonary venous connection",27,0],
    [37,3,"Supracardiac",36,0],
    [38,3,"Intracardiac",36,0],
    [39,3,"Infracardiac",36,0],
    [40,3,"Mixed",36,0],
    [41,2,"Partially anomalous pulmonary venous connectionse",27,0],
    [42,3,"Scimitar syndrom",41,0],
    [43,1,"Ventricular anomalies",0,0],
    [44,2,"Ventricular imbalance",43,0],
    [45,3,"Dominant LV",44,0],
    [46,3,"Dominant RV",44,0],
    [47,2,"Double inlet LV",43,0],
    [48,2,"Functionally univentricular heart",43,0],
    [49,2,"Tricuspid valvar abnormality",43,0],
    [50,2,"Tricuspid valvar dysplasia",43,0],
    [51,3,"Mucoid thickening",50,0],
    [52,2,"Ebstein's malformation of tricuspid valve",43,0],
    [53,2,"Tricuspid atresia",43,0],
    [54,2,"RV abnormality",43,0],
    [55,2,"RV wall paper thin",43,0],
    [56,3,"Uhl's anomaly",55,0],
    [57,2,"Mitral valvar abnormality",43,0],
    [58,2,"Mitral valvar dysplasia",43,0],
    [59,3,"Mucoid thickening",58,0],
    [60,2,"Straddling mitral valve",43,0],
    [61,2,"Supravalvar mitral ring",43,0],
    [62,2,"Mitral atresia",43,0],
    [63,2,"LV dilation",43,0],
    [64,2,"LV hypertrophy",43,0],
    [65,2,"Primary LV endocardial fibroelastosis",43,0],
    [66,2,"LV diverticulum - congenital",43,0],
    [67,1,"VALVULAR abnormality flow",0,0],
    [68,2,"Tricuspid regurgitation",67,0],
    [69,2,"Tricuspid valve stenosis",67,0],
    [70,2,"Mitral valve regurgitation",67,0],
    [71,2,"Mitral valve stenosis",67,0],
    [72,2,"Pulmonary valve regurgitation",67,0],
    [73,2,"Pulmonary valve stenosis",67,0],
    [74,2,"Aortic valve regurgitation",67,0],
    [75,2,"Aortic valve stenosis",67,0],
    [76,2,"Bicuspid aortic valve susp",67,0],
    [77,1,"SEMILUNAR VALVAR ABNORMALITY",0,0],
    [78,2,"Pulmonary valvar abnormality susp",77,0],
    [79,2,"Pulmonary valvar hypoplasia",77,0],
    [80,2,"Subpulmonary stenosis",77,0],
    [81,2,"Aortic cusp(s) hypoplasia",77,0],
    [82,2,"Aortic valvar ring hypoplasia",77,0],
    [83,2,"Aortic valvar atresia",77,0],
    [84,2,"LV outflow tract obstruction",77,0],
    [85,2,"Subaortic stenosis",77,0],
    [86,1,"GREAT ARTERIES ABNORMALITY",0,0],
    [87,2,"Pulmonary trunk dilation",86,0],
    [88,3,"MPA dilatation",87,0],
    [89,2,"Pulmonary arterial abnormality",86,0],
    [90,2,"Confluent pulmonary arteries",86,0],
    [91,2,"Pulmonary arterial hypoplasia",86,0],
    [92,2,"RPA hypoplasia",86,0],
    [93,2,"LPA hypoplasia",86,0],
    [94,2,"RPA & LPA hypoplasia",86,0],
    [95,2,"Ascending aorta hypoplasia",86,0],
    [96,2,"Ascending aorta atresia",86,0],
    [97,2,"Arterial duct dependent pulmonary circulation",86,0],
    [98,2,"Arterial duct dependent systemic circulation",86,0],
    [99,1,"Aortic arch abnormality",0,0],
    [100,2,"Double aortic arch",99,0],
    [101,2,"Right aortic arch",99,0],
    [102,2,"Aortic coarctation susp",99,0],
    [103,2,"Aortic arch hypoplasia (tubular)",99,0],
    [104,2,"Interrupted aortic arch susp",99,0],
    [105,2,"Tortuosity of aortic arch",99,0],
    [106,2,"Aberrant origin R subclavian artery",99,0],
    [107,2,"Aberrant origin L subclavian artery",99,0],
    [108,2,"R arterial duct in R arch",99,0],
    [109,2,"Coronary fistula susp",99,0],
    [110,1,"COMPLEX CARDIAC (Conotruncal) MALFORMATIONS",0,0],
    [111,2,"Double outlet RV",110,0],
    [112,3,"Fallot type",111,0],
    [113,3,"transposition type",111,0],
    [114,2,"Common arterial trunk",110,0],
    [115,2,"Malposition of great arteries",110,0],
    [116,2,"Transposition of great arteries (TGA)",110,0],
    [117,2,"Parallel course of great arteries",110,0],
    [118,2,"Tetralogy of Fallot",110,0],
    [119,2,"Pulmonary atresia + VSD (including Fallot type)",110,0],
    [120,2,"Major systemic-to-pulmonary collateral artery (MAPCA)",110,0],
    [121,2,"Absent pulmonary valve syndrome - Fallot-type",110,0],
    [122,2,"Non confluent pulmonary arteries susp",110,0],
    [123,2,"Pulmonary atresia + intact ventricular septum",110,0],
    [124,2,"VSD + malaligned outlet septum",110,0],
    [125,2,"Congenitally corrected transposition of great arteries",110,0],
    [126,1,"HLHS",0,0],
    [127,2,"Hypoplastic left heart syndrome",126,0],
    [128,2,"Aortic atresia + Mitral hypoplasia",126,0],
    [129,2,"Aortic Hypoplasia +Mitral Atresia",126,0],
    [130,2,"Aortic Hypoplasia + Mitral Hypoplasia",126,0 ],
    [131,1,"AVSD",0,0],
    [132,2,"Atrioventricular septal defect",132,0],
    [133,2,"AVSD: isolated atrial component (primum ASD)",132,0  ],
    [134,2,"AVSD: isolated ventricular component",132,0  ],
    [135,2,"AVSD: atrial & ventricular components (complete)",132,0  ],
    [136,2,"AVSD with hypoplastic LV",132,0  ],
    [137,2,"AVSD with hypoplastic RV",132,0  ],
    [138,2,"AV septal defect and Tetralogy of Fallot",132,0  ],
    [139,2,"AVSD with separate AV orifices intermediate AVSD",132,0  ],
    [140,2,"AVSD with common AV orifice",132,0 ],
    [141,2,"AVSD AV valvar regurgitation" ,132,0 ],
    [142,1,"Truncus arteriosus, ap window",0,0  ],
    [143,2,"Aorto-pulmonary window susp",142,0  ],
    [144,2,"Common arterial trunk",142,0  ],
    [145,2,"Common arterial trunk + common origin of PAs (type I)",142,0  ],
    [146,2,"Common arterial trunk + separate origin of PAs (type II)",142,0  ],
    [147,2,"Common arterial trunk + widely separate origin of PAs (type III)",142,0  ],
    [148,2,"Common arterial trunk with aortic arch obstruction",142,0  ],
    [149,2,"Truncal valvar dysplasia (mucoid thickening)",142,0  ],
    [150,2,"Truncal valvar stenosis",142,0  ],
    [151,2,"Truncal valvar regurgitation",142,0  ],
    [152,1,"MULTIPLE PREGNANCY",0,0  ],
    [153,2,"Twin pregnancy",152,0  ],
    [154,2,"Bichorionic biamniotic  twin pregnancy",152,0  ],
    [155,2,"Monochorionic biamniotic  twin pregnancy",152,0  ],
    [156,2,"Monochorionic monoamniotic  twin pregnancy",152,0  ],
    [157,2,"Triplet pregnancy",152,0  ],
    [158,1,"Maternal infection/illness",0,0  ],
    [159,2,"Fetal cytomegalovirus syndrome",158,0  ],
    [160,2,"Fetal toxoplasmosis syndrome",158,0  ],
    [161,2,"Fetal parvovirus infection",158,0  ],
    [162,2,"Maternal phenylketonuria disruption syndrome",158,0  ],
    [163,2,"Maternal SLE",158,0  ],
    [164,2,"Fetal hydrops",158,0  ],
    [165,2,"Fetal anaemia",158,0  ],
    [166,1,"FETAL ABN",0,0  ],
    [167,2,"Fetal hydrops",166,0 ],
    [168,2,"Fetal anaemia",166,0  ],
    [169,2,"In utero death",166,0  ],
    [170,2,"Fetal abnormal venous Doppler flow",166,0  ],
    [171,2,"VACTERL association",166,0  ],
    [172,1,"CHROMOSOMAL ANOMALY",0,0  ],
    [173,2,"Trisomy 21 - Down's syndrome",172,0  ],
    [174,2,"Trisomy 18 - Edwards' syndrome",172,0  ],
    [175,2,"Trisomy 13 - Patau's syndrome",172,0  ],
    [176,2,"45X0 - Turner's syndrome",172,0  ],
    [177,2,"XXY - Klinefelter's syndrome",172,0  ],
    [178,2,"Deletion 4p-",172,0  ],
    [179,2,"Cri-du-chat syndrome - deletion 5p-",172,0  ],
    [180,2,"Cat-Eye syndrome - Trisomy 22pter-q11",172,0  ],
    [181,2,"Fragile X syndrome - marker Xq27.3",172,0  ],
    [182,2,"Chromosomal anomaly (DESCRIBE)",172,0  ],
    [183,2,"Chromosome point mutation / microdeletion",172,0  ],
    [184,2,"22q11 microdeletion - CATCH 22",172,0  ],
    [185,2,"DiGeorge sequence",172,0  ],
    [186,2,"Velo-cardio-facial (Shprintzen) syndrome",172,0  ],
    [187,2,"Williams syndrome (infantile hypercalcaemia)",172,0  ],
    [188,2,"Hypertrophic cardiomyopathy with genetic marker",172,0  ],
    [189,2,"Dilated cardiomyopathy with genetic marker",172,0  ],
    [190,2,"Chromosome point mutation / microdeletion (DESCRIBE)",172,0  ],
    [191,2,"Hereditary disorder of connective tissue associated with heart disease",172,0  ],
    [192,2,"Ehlers-Danlos syndrome type IV",172,0  ],
    [193,2,"Marfan syndrome maternal",172,0  ],
    [194,2,"Pseudoxanthoma elasticum syndrome",172,0  ],
    [195,2,"Osteogenesis imperfecta",172,0  ],
    [196,2,"Cutis laxa syndrome",172,0  ],
    [197,2,"Hereditary disorder of connective tissue associated with heart disease (DESCRIBE)",172,0  ],
    [198,2,"Syndrome/association with cardiac involvement",172,0  ],
    [199,2,"Alagille syndrome: arteriohepatic dysplasia",172,0  ],
    [200,2,"Beckwith-Wiedemann syndrome",172,0  ],
    [201,2,"Holt-Oram (heart-hand I) syndrome",172,0  ],
    [202,2,"Noonan syndrome",172,0  ],
    [203,2,"Treacher Collins syndrome",172,0  ],
    [204,2,"Tuberous sclerosis",172,0  ],
    [205,2,"CHARGE association",172,0  ],
    [206,2,"Cornelia de Lange syndrome",172,0  ],
    [207,2,"Isomerism sequence (asplenia/polysplenia; Ivemark syndrome)",172,0  ],
    [208,2,"Goldenhar syndrome: facioauriculovertebral spectrum",172,0  ],
    [209,2,"Klippel-Feil sequence",172,0  ],
    [210,2,"Pentalogy of Cantrell",172,0  ],
    [211,2,"Pierre Robin syndrome",172,0  ],
    [212,1,"CARDIOMYOPATHY",0,0  ],
    [213,2,"Cardiomyopathy susp",212,0  ],
    [214,2,"Hypertrophic cardiomyopathy",212,0  ],
    [215,2,"Dilated cardiomyopathy",212,0  ],
    [216,2,"Endocardial fibroelastosis",212,0  ],
    [217,2,"LV myocardial non-compaction",212,0  ],
    [218,2,"Benign heart tumour",212,0],
    [219,3,"Rhabdomyoma",218,0],
    [220,3,"Multiple rhabdomyoma",218,0  ],
    [221,3,"Fibroma",218,0  ],
    [222,3,"Teratoma",218,0  ],
    [223,3,"Myxoma",218,0  ],
    [224,1,"SUPRACARDIAC MALFORMATIONS",0,0  ],
    [225,2,"Bovine arch variant",224,0  ],
    [226,2,"LBCV intratymic",224,0  ],
    [227,2,"Bilateral SVC",224,0  ],
    [228,2,"IVC interruption with azygos continuation",224,0  ],
    [229,2,"Vascular ring",224,0  ],
    [230,2,"Vascular ring due to aberrant subclavian artery & bilateral arterial ducts",224,0  ],
    [231,2,"Pulmonary arterial sling",224,0  ],
    [232,2,"Distal origin of innominate artery with tracheal compression",224,0  ],
    [233,2,"Vascular ring ",224,0  ],
    [234,1,"FETAL ARRHYTHMIA",0,0  ],
    [235,2,"Fetal arrhythmia susp",234,0  ],
    [236,2,"Supraventricular rhythm disturbance",234,0  ],
    [237,2,"Supraventricular tachycardia",234,0  ],
    [238,2,"Sinus node dysfunction (sick sinus)",223,0  ],
    [239,2,"Sinus bradycardia",234,0  ],
    [240,2,"Sinus tachycardia",234,0  ],
    [241,2,"Ectopic (automatic) atrial tachycardia",234,0  ],
    [242,2,"Premature atrial complexes",234,0  ],
    [243,2,"Premature atrial complexes with blocked conduction",234,0  ],
    [244,2,"Premature atrial complexes with atrial bigeminy",234,0  ],
    [245,2,"Atrial flutter ",234,0  ],
    [246,2,"Ventricular tachycardia",234,0  ],
    [247,2,"Ectopic ventricular tachycardia",234,0  ],
    [248,2,"1st degree AV block",234,0  ],
    [249,2,"2nd degree AV block",234,0  ],
    [250,2,"Mobitz I 2nd degree AV block (Wenckebach)",234,0  ],
    [251,2,"Mobitz II 2nd degree AV block",234,0  ],
    [252,2,"Complete AV block",234,0  ],
    [253,1,"HETEROTAXY SYNDROMES",0,0  ],
    [254,2,"Laevocardia: heart predominantly in L hemithorax",253,0  ],
    [255,2,"Apex of heart to left",253,0  ],
    [256,2,"Dextrocardia: heart predominantly in R hemithorax",253,0  ],
    [257,2,"Midline heart (mesocardia)",253,0  ],
    [258,2,"Heart rotated to right (dextrorotation)",253,0  ],
    [259,2,"Apex of heart to right",253,0  ],
    [260,2,"Midline apex of heart",253,0  ],
    [261,2,"Position or morphology of thoraco-abdominal organs abnormal",253,0  ],
    [262,2,"Total mirror imagery (atrial situs inversus)",253,0  ],
    [263,2,"Right isomerism ('asplenia')",253,0  ],
    [264,2,"Left isomerism ('polysplenia')",253,0  ],
    [265,2,"Usual atrial arrangement (atrial situs solitus)",253,0  ],
    [266,2,"Mirror image atrial arrangement (atrial situs inversus)",253,0  ],
    [267,2,"Isomerism of RA appendages (R isomerism)",253,0  ],
    [268,2,"Isomerism of LA appendages (L isomerism)",253,0  ],
    [269,1,"LESS COMMON DIAGNOSIS",0,0  ],
    [270,2,"Pulmonary vein stenosis",269,0  ],
    [271,2,"Pulmonary arterial aneurysm",269,0  ],
    [272,2,"Extrathoracic heart (ectopia cordis)",269,0  ],
    [273,2,"RV aneurysm",269,0  ],
    [274,2,"LV aneurysm",269,0  ],
    [275,2,"Abnormal isthmic flow",269,0  ]
]